export default __webpack_public_path__ + "static/media/6B1_keift_saddle.4652ca80.png";